var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgResize = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 17 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.177 9.826 7.174 8.823l-4.692 4.692V8.857H1.071v7.09h7.072v-1.429H3.485zm.646-2.652 1.003 1.003 4.692-4.692v4.658h1.428V1.054H8.857v1.428h4.658z"
})));
export default SvgResize;